// extracted by mini-css-extract-plugin
export var createdDate = "_ig-1";
export var divider = "_ig-2";
export var headerDivider = "_ig-3";
export var messagesCard = "_ig-0";
export var messagesContainer = "_ig-7";
export var messagesContainerWrapper = "_ig-4";
export var pointerCapturingButtonBoxes = "_ig-a";
export var showLeftPanelButton = "_ig-9";
export var showMoreButton = "_ig-c";
export var showMoreButtonContainer = "_ig-b";
export var summaryTitle = "_ig-6";
export var systemMessageCardWrapper = "_ig-d";
export var topButtons = "_ig-8";
export var withPadding = "_ig-5";